/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { AlarmsPanelModule } from 'app/feature/monitor/alarms-and-events/alarms-panel/alarms-panel.module';
import { AnomalyPanelModule } from 'app/feature/monitor/alarms-and-events/anomaly-panel/anomaly-panel.module';
import { TaskPanelModule } from 'app/feature/monitor/task/task-panel/task-panel.module';

import { GlobalSearchModule } from '../global-search/global-search.module';
import { HeaderCommonTaskModule } from '../header-common-task/header-common-task.module';
import { HeaderSettingsModule } from '../header-settings/header-settings.module';
import { OtaUpgradeModule } from '../header-settings/upgrade/ota-upgrade-panel/ota-upgrade.modules';
import { SystemUpgradeModule } from '../header-settings/upgrade/system-upgrade-panel/system-upgrade.modules';
import { UpgradeModule } from '../header-settings/upgrade/upgrade-panel/upgrade.modules';
import { HelpMemuModule } from '../help-memu/help-memu.module';
import { QrcodeModule } from '../qrcode/qrcode.module';
import { SmartAssistantSwitchModule } from '../smart-assistant/smart-assistant-switch/smart-assistant-switch.module';
import { SmartguiSwitchModule } from '../smartgui-switch/smartgui-switch.module';
import { SimpleModeSwitchModule } from './../simple-mode-switch/simple-mode-switch.module';
import { HeaderComponent } from './header.component';
import { HeaderLanguageModule } from './header-language/header-language.module';


@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        TaskPanelModule,
        AlarmsPanelModule,
        HeaderSettingsModule,
        HelpMemuModule,
        HeaderCommonTaskModule,
        SmartguiSwitchModule,
        QrcodeModule,
        UpgradeModule,
        SystemUpgradeModule,
        OtaUpgradeModule,
        GlobalSearchModule,
        SimpleModeSwitchModule,
        AnomalyPanelModule,
        HeaderLanguageModule,
        SmartAssistantSwitchModule,
    ],
    exports: [HeaderComponent],
    declarations: [HeaderComponent],
})
export class HeaderModule { }
